import {
    AppWindow,
    Box,
    Lock,
    Workflow,
    Wrench,
    PencilRuler,
    Layers,
    Frame,
    HardDrive,
    Brain,
    Cable,
    Bot,
    BookOpen,
    Settings2,
    ChartNoAxesColumn,
    LayoutDashboard,
    Sparkles,
    Users,
} from 'lucide-react';
import { useParams } from 'react-router-dom';

import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    SidebarSeparator,
} from '@/components/ui/sidebar';
import SidebarNavGroup from '@/components/SidebarNavGroup';
import { OrganizationSwitcher } from './OrganizationSwitcher/';
import { AvatarMenu } from '@/components/AvatarMenu';
import { StyledSidebarContent } from './styled';

const buildMenuItems = [
    {
        title: 'Workflows',
        path: 'workflows',
        icon: Workflow,
    },
    {
        title: 'Templates',
        path: 'templates',
        icon: Layers,
    },
    {
        title: 'Tools',
        path: 'tools',
        icon: Wrench,
    },
    {
        title: 'Skills',
        path: 'skills',
        icon: Sparkles,
    },
    {
        title: 'Prompts',
        path: 'prompts',
        icon: PencilRuler,
    },
    {
        title: 'Configs',
        path: 'configs',
        icon: Settings2,
    },
    {
        title: 'Files',
        path: 'files',
        icon: HardDrive,
    },
    {
        title: 'Canvas',
        path: 'canvas',
        icon: Frame,
    },
    {
        title: 'Sandboxes',
        path: 'sandboxes',
        icon: Box,
    },
];

const observabilityMenuItems = [
    {
        title: 'Metrics',
        path: 'metrics',
        icon: ChartNoAxesColumn,
    },
    {
        title: 'Dashboards',
        path: 'dashboards',
        icon: LayoutDashboard,
    },
];

const integrationsMenuItems = [
    {
        title: 'Apps',
        path: 'apps',
        icon: AppWindow,
    },
    {
        title: 'Connections',
        path: 'connections',
        icon: Cable,
    },
    {
        title: 'Secrets',
        path: 'secrets',
        icon: Lock,
    },
];

const settingsMenuItems = [
    {
        title: 'Team',
        path: 'team',
        icon: Users,
    },
    {
        title: 'Models',
        path: 'models',
        icon: Brain,
    },
    {
        title: 'System Agents',
        path: 'system-agents',
        icon: Bot,
    },
];

export function AppSidebar() {
    const { agentId } = useParams();

    const buildItems = buildMenuItems.map(item => ({
        ...item,
        url: `/agents/${agentId}/${item.path}`,
    }));

    const observabilityItems = observabilityMenuItems.map(item => ({
        ...item,
        url: `/agents/${agentId}/${item.path}`,
    }));

    const integrationsItems = integrationsMenuItems.map(item => ({
        ...item,
        url: `/agents/${agentId}/${item.path}`,
    }));

    const settingsItems = settingsMenuItems.map(item => ({
        ...item,
        url: `/agents/${agentId}/${item.path}`,
    }));

    return (
        <Sidebar>
            <SidebarHeader className="p-4">
                <OrganizationSwitcher />
            </SidebarHeader>
            <SidebarContent>
                <StyledSidebarContent>
                    <SidebarNavGroup label="Build" items={buildItems} />
                    <SidebarNavGroup label="Observability" items={observabilityItems} />
                    <SidebarNavGroup label="Integrations" items={integrationsItems} />
                    <SidebarNavGroup label="Settings" items={settingsItems} />
                </StyledSidebarContent>
            </SidebarContent>
            <SidebarFooter>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild className="text-md">
                            <a
                                href="https://voxity.gitbook.io/voxity-agentic-workflows"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <BookOpen />
                                <span>Documentation</span>
                            </a>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
                <div className="px-3">
                    <SidebarSeparator className="mx-0" />
                </div>
                <AvatarMenu variant="app" />
            </SidebarFooter>
        </Sidebar>
    );
}
